import { render, staticRenderFns } from "./GsaList.vue?vue&type=template&id=f2a1856e&"
import script from "./GsaList.vue?vue&type=script&lang=js&"
export * from "./GsaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports